module.exports = __webpack_public_path__ + "img/integridad-abril.aaaf5fe1.png";